import { grayColor, hexToRgb } from 'assets/jss/material-dashboard-pro-react';

export const LINK_BORDER_RADIUS = '3px';

export const LINK_FOCUSED_BG_COLOR = `rgba(${hexToRgb(grayColor[17])}, 0.2)`;
